import PropTypes from "prop-types"
import { Table } from "@mui/material"
import { sortData } from "helpers/contributorsSort"
import ContributorsTableContent from "components/contributors-table-content"
import ContributorsTableGroupHead from "components/contributors-table-group-head"
import { THRESHOLD_PARAMS } from "helpers/threshold"

function ContributorsTotal({ disabled, data, show, openFactorProfile, displayTypeName, factorTable, groupSort, groupOrder, thresholdParams }) {
  return <Table className="factor-sensitivity-contributors">
    <ContributorsTableGroupHead {...{
      tooltipText: "1 STD Factor Impact (%)",
      displayTypeName,
      groupOrder,
      groupSort,
      label: "1 STD Factor Impact (%)",
    }}
    />
    <ContributorsTableContent
      factors
      noPercent
      allFactors
      openFactorProfile={openFactorProfile}
      data={sortData(data, groupOrder)}
      show={show}
      factorTable={factorTable}
      disabled={disabled}
      thresholdParams={thresholdParams}
    />
  </Table>
}

ContributorsTotal.propTypes = {
  disabled: PropTypes.bool,
  data: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  displayTypeName: PropTypes.string.isRequired,
  openFactorProfile: PropTypes.func,
  show: PropTypes.func.isRequired,
  factorTable: PropTypes.bool.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  thresholdParams: THRESHOLD_PARAMS,
}

export default ContributorsTotal
